export const HELP_PLAYLIST_URL_ES = 'https://www.youtube.com/embed/videoseries?list=PLRB1kYKNADxIbN6aXzqjZGAQjx-gLCtpV';
export const HELP_PLAYLIST_URL_EN = 'https://www.youtube.com/embed/videoseries?list=PLRB1kYKNADxI4z4TKlRCSwRBRkL8j9Q3W';
export const SUPPORT_EMAIL = 'soporte@dynameat.io';
export const SUPPORT_PHONE = '+34 622 102 900';
